<template>
  <div class="content-manager" v-can="'admin'">
      <div class="grid">
        <div class="card col col-3">
          <img src="../../../assets/businesskit.svg">
          <h3>{{ $t("ui.content_manager.first-card.title")}}</h3>
          <p>{{ $t("ui.content_manager.first-card.subtitle")}}</p>
          <a class="btn btn-primary" v-bind:href="businessKitLink()" target="_blank">
            {{ $t("ui.content_manager.first-card.btn")}}
          </a>
        </div>
        <div class="card col col-3">
          <img src="../../../assets/forms.svg">
          <h3>{{ $t("ui.content_manager.second-card.title")}}</h3>
          <p>{{ $t("ui.content_manager.second-card.subtitle")}}</p>
          <a class="btn btn-primary" @click="openForms()">{{ $t("ui.content_manager.second-card.btn")}}</a>
          <external-form-create></external-form-create>
        </div>
        <div v-if="!currentPlanIsTalent" class="card col col-3">
          <img src="../../../assets/leadsheet.svg">
          <h3>{{ $t("ui.content_manager.third-card.title")}}</h3>
          <p>  {{ $t("ui.content_manager.third-card.subtitle")}}</p>
          <a href="https://fanomena.io" target="_blank" class="btn btn-primary">{{ $t("ui.content_manager.third-card.btn")}}</a>
        </div>
      </div>
  </div>
</template>
<script>
import ExternalFormCreate from '@pages/external_forms/ExternalFormCreate'
import { EventBus } from '@/EventBus.js';
import Permissions from '@/classes/Permission'

export default {
components: {ExternalFormCreate},
data(){
  return{
    isOpen: false,
  }
},
computed: {
  allowedAccessForms() {
    return Permissions.planCan('allowed_forms')
  },
  currentPlanIsTalent() {
    return this.$store.getters.getCurrentPlanIsTalent
  }
},
methods: {
  openForms(){
    if (!this.allowedAccessForms) {
      this.$store.commit('SET_NOT_ALLOWED_MODAL_SHOWN', true)
    } else {
      EventBus.$emit('open', true);
    }
  },
  businessKitLink() {
    let config = this.$store.state.organization_config.eventbaxx_auth_token
    if (config) {
      return 'https://businesskit.fanomena.io/auth_login/' + config.content
    } else {
      return 'https://businesskit.fanomena.io/auth_login/'
    }
  },

}
}
</script>
<style lang="scss">
.content-manager {
  .field {
    text-align: left;
  }
  .field-radio .field--wrapper {
    margin-top: 6px;
  }
}
</style>
<style lang="scss" scoped>
.content-manager{

  .grid {
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100vh;
  }
  .col {
    flex-basis: 100%;
  }

  .card {
    max-width: 400px;
    margin: 0 1em;
    min-height: 460px;
    padding: 1em;
    display: flex;
    flex-direction: column;
    box-shadow: none;
    background: $paper-lighter;
    img {
      margin-top: 2em;
    }
    h3 {
      font-size: 26px;
      line-height: 32px;
      color: $ink;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      height: 160px;
      margin-top: 0;
      color: $ink-light;
    }
    .btn {
      margin-top: 1.5em;
      line-height: 2.6;
      font-weight: 800;
      font-size: 15px;
      @media(min-width: 1080px) and (max-width:1248px) {
        margin-top: 3.5em;
      }
    }
  }
  @media(min-width: 1080px) {
    .col-3 {
      flex-basis: 33.3333%;
    }
  }
  @media(max-width: 1080px) {
    .grid {
      flex-direction: column;
    }
    .card {
      margin: 0 auto 1.5em;
    }
  }
}
@media(max-width: 800px) {
  .content-manager {
    margin-top: 5em;
  }
}
</style>



// WEBPACK FOOTER //
// ContentManager.vue?5f705cf2